// import React, { useState, useEffect } from "react";
// import { FiSave, FiDownload, FiPlus, FiTrash2, FiFileText } from "react-icons/fi";
// import { requirementService } from "../../services/ApiService";
// import "./Requirement.css";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { saveAs } from "file-saver";
// import htmlDocx from "html-docx-js/dist/html-docx";

// const AddRequirement = () => {

//   const [loading, setLoading] = useState(false);
//   const [requirementId, setRequirementId] = useState("");
//   const [customStValue, setCustomStValue] = useState("");
//   const [showProjectModal, setShowProjectModal] =
// useState(false);

// const [projectForm, setProjectForm] =
//   useState({
//     name: "",
//     description: "",
//   });

// const [projectLoading, setProjectLoading] =
//   useState(false);
  
//   // New States for Projects Dropdown
//   const [projects, setProjects] = useState([]);
//   const [projectsLoading, setProjectsLoading] = useState(true);

//   // Dynamic Document Upload Storage Tracking States
//   const [uploadedDocuments, setUploadedDocuments] = useState([
//     { document_name: "", file_obj: null }
//   ]);
//   const [versionRemark, setVersionRemark] = useState("");
  
//   const [formData, setFormData] = useState({
//     project: "", // Holds selected project ID
//     type: "SR",
//     category: "FR",
//     version: "V1",
//     requirement_title_reference: "",
//     requirement_purpose: "",
//     requirement_description: "",
//     requirement_moscow: "Must Have",
//     priority: "High",
//     reference: "",
//     technical_issues: "",
//     risk: "",
//     high_level_dependencies: "",
//     acceptance_criteria: "",
//     verification_method: "",
//   });

//   const [features, setFeatures] = useState([
//     { title: "", description: "", feature: "", moscow: "Must Have", risk: "", dependencies: "", priority: "High", self_standard_mapping: "", target_standard_achievement: "" }
//   ]);

//   // 1. Add this tracking state at the top of your component file
//   const [toast, setToast] = useState({ show: false, message: "", type: "" });

//   // Helper function to handle timing out the notification banner auto-dismissal
//   const triggerToast = (message, type = "success") => {
//     setToast({ show: true, message, type });
//     setTimeout(() => {
//       setToast({ show: false, message: "", type: "" });
//     }, 5000); // Automatically fades out cleanly after 5 seconds
//   };




// const fetchProjectsList =
//   async (
//     selectFirst = false
//   ) => {
//     try {

//       setProjectsLoading(
//         true
//       );

//       const responseData =
//         await requirementService.getProjects();

//       let actualProjectsArray =
//         [];

//       // Defensive check
//       if (
//         Array.isArray(
//           responseData
//         )
//       ) {
//         actualProjectsArray =
//           responseData;
//       } else if (
//         responseData &&
//         Array.isArray(
//           responseData.results
//         )
//       ) {
//         actualProjectsArray =
//           responseData.results;
//       } else if (
//         responseData &&
//         Array.isArray(
//           responseData.projects
//         )
//       ) {
//         actualProjectsArray =
//           responseData.projects;
//       } else if (
//         responseData &&
//         typeof responseData ===
//           "object"
//       ) {
//         const foundArray =
//           Object.values(
//             responseData
//           ).find((val) =>
//             Array.isArray(
//               val
//             )
//           );

//         if (foundArray) {
//           actualProjectsArray =
//             foundArray;
//         }
//       }

//       setProjects(
//         actualProjectsArray
//       );

//       // Select first project
//       if (
//         selectFirst &&
//         actualProjectsArray.length >
//           0
//       ) {
//         setFormData(
//           (prev) => ({
//             ...prev,
//             project:
//               actualProjectsArray[0]
//                 .id,
//           })
//         );
//       }

//       return actualProjectsArray;

//     } catch (err) {

//       console.error(
//         "Error loading project array:",
//         err
//       );

//       setProjects([]);

//       return [];

//     } finally {

//       setProjectsLoading(
//         false
//       );
//     }
//   };


// useEffect(() => {
//   fetchProjectsList(true);
// }, []);

//   // Auto-generate ID based on selections
//   useEffect(() => {


//     if (!formData.project) return;

//     const fetchIncrementedId = async () => {
//       try {
//         // Evaluate the category, checking if the "Global Standards (ST)" input field override is used
//         const finalCategory = formData.category === "ST" ? (customStValue || "ST") : formData.category;

//         // Package up the exact configuration matrix payload
//         const queryPayload = {
//           project: formData.project,
//           type: formData.type,
//           category: finalCategory,
//           version: formData.version
//         };

//         const result = await requirementService.generateRequirementId(queryPayload);
        
//         if (result && result.next_requirement_id) {
//           setRequirementId(result.next_requirement_id);
//         }
//       } catch (error) {
//         console.error("Failed to query live requirement increment suffix ID:", error);
        
//         // Fallback placeholder safely visible to engineers if the backend drops off or throws a 404/500
//         const localCategory = formData.category === "ST" ? (customStValue || "ST") : formData.category;
//         setRequirementId(`${formData.type}/${localCategory}/${formData.version}/001`);
//       }
//     };

//     // Trigger lookup debounced or directly on configuration parameter adjustments
//     fetchIncrementedId();
//     // const nextNumber = "0001"; 
//     // const finalCategory = formData.category === "ST" ? (customStValue || "ST") : formData.category;
//     // const generatedId = `${formData.type}/${finalCategory}/${formData.version}/${nextNumber}`;
//     // setRequirementId(generatedId);
//   }, [formData.type, formData.category, formData.version, customStValue]);

//   const handleChange = (field, value) => setFormData({ ...formData, [field]: value });

//   const handleFeatureChange = (index, field, value) => {
//     const updated = [...features];
//     updated[index][field] = value;
//     setFeatures(updated);
//   };

//   // Document array helper interaction hooks
//   const handleDocChange = (index, field, value) => {
//     const updatedDocs = [...uploadedDocuments];
//     updatedDocs[index][field] = value;
//     setUploadedDocuments(updatedDocs);
//   };

//   const addDocumentRow = () => {
//     setUploadedDocuments([...uploadedDocuments, { document_name: "", file_obj: null }]);
//   };

//   const removeDocumentRow = (index) => {
//     setUploadedDocuments(uploadedDocuments.filter((_, i) => i !== index));
//   };

//   const downloadPDF = () => {
//     const doc = new jsPDF();
//     doc.setFontSize(18);
//     doc.text("Requirement Document", 14, 20);
//     doc.setFontSize(12);
//     doc.text(`Requirement ID: ${requirementId}`, 14, 30);

//     const details = [
//       ["Title", formData.requirement_title_reference],
//       ["Purpose", formData.requirement_purpose],
//       ["Description", formData.requirement_description],
//       ["MoSCoW", formData.requirement_moscow],
//       ["Priority", formData.priority],
//       ["Reference", formData.reference],
//       ["Technical Issues", formData.technical_issues],
//       ["Risk", formData.risk],
//       ["Dependencies", formData.high_level_dependencies],
//       ["Acceptance Criteria", formData.acceptance_criteria],
//       ["Verification Method", formData.verification_method],
//     ];

//     autoTable(doc, {
//       startY: 40,
//       head: [["Field", "Value"]],
//       body: details,
//     });

//     doc.text("Features", 14, doc.lastAutoTable.finalY + 15);

//     autoTable(doc, {
//       startY: doc.lastAutoTable.finalY + 20,
//       head: [["Title", "Description", "Feature", "MoSCoW", "Risk", "Dependencies", "Priority"]],
//       body: features.map((f) => [
//         f.title,
//         f.description,
//         f.feature,
//         f.moscow,
//         f.risk,
//         f.dependencies,
//         f.priority,
//       ]),
//     });

//     doc.save(`${requirementId}.pdf`);
//   };

//   const downloadDOC = () => {
//     const featureRows =
//       features.length > 0
//         ? features
//             .map(
//               (f) => `
//         <tr>
//           <td>${f.title || ""}</td>
//           <td>${f.description || ""}</td>
//           <td>${f.feature || ""}</td>
//           <td>${f.moscow || ""}</td>
//           <td>${f.risk || ""}</td>
//           <td>${f.dependencies || ""}</td>
//           <td>${f.priority || ""}</td>
//           <td>${f.self_standard_mapping || ""}</td>
//           <td>${f.target_standard_achievement || ""}</td>
//         </tr>
//       `
//             )
//             .join("")
//         : `<tr><td colspan="9"></td></tr>`;

//     const htmlContent = `
//     <html>
//     <head>
//       <style>
//         body { font-family: Arial, sans-serif; margin: 20px; }
//         table { width: 100%; border-collapse: collapse; table-layout: fixed; }
//         td, th { border: 1px solid black; padding: 6px; font-size: 12px; word-wrap: break-word; vertical-align: top; }
//         .label-cell { width: 18%; font-weight: bold; }
//         .feature-title { font-weight: bold; }
//         .feature-table td, .feature-table th { font-size: 10px; text-align: center; }
//         .big-row { height: 50px; }
//       </style>
//     </head>
//     <body>
//       <div>${formData.requirement_title_reference}</div>
//       <table>
//         <tr><td class="label-cell">Requirement ID</td><td>${requirementId}</td></tr>
//         <tr class="big-row"><td class="label-cell">Requirement Purpose</td><td>${formData.requirement_purpose}</td></tr>
//         <tr class="big-row"><td class="label-cell">Requirement Description</td><td>${formData.requirement_description}</td></tr>
//         <tr><td class="label-cell">Requirement MoSCoW</td><td>${formData.requirement_moscow}</td></tr>
//         <tr>
//           <td class="label-cell feature-title">Features</td>
//           <td style="padding:0;">
//             <table class="feature-table">
//               <thead>
//                 <tr>
//                   <th>Title</th><th>Description</th><th>Feature</th><th>MoSCoW</th><th>Risk</th><th>Dependencies</th><th>Priority</th><th>Self Standard Mapping</th><th>Target Standard Achievement</th>
//                 </tr>
//               </thead>
//               <tbody>${featureRows}</tbody>
//             </table>
//           </td>
//         </tr>
//         <tr><td class="label-cell">Priority</td><td>${formData.priority}</td></tr>
//         <tr class="big-row"><td class="label-cell">Reference</td><td>${formData.reference}</td></tr>
//         <tr class="big-row"><td class="label-cell">Technical Issues</td><td>${formData.technical_issues}</td></tr>
//         <tr class="big-row"><td class="label-cell">Risk</td><td>${formData.risk}</td></tr>
//         <tr class="big-row"><td class="label-cell">High-level Dependencies</td><td>${formData.high_level_dependencies}</td></tr>
//         <tr class="big-row"><td class="label-cell">Acceptance Criteria</td><td>${formData.acceptance_criteria}</td></tr>
//         <tr class="big-row"><td class="label-cell">Verification Method</td><td>${formData.verification_method}</td></tr>
//       </table>
//     </body>
//     </html>`;

//     const converted = htmlDocx.asBlob(htmlContent);
//     saveAs(converted, `${requirementId}.docx`);
//   };
// const handleCreateProject =
//   async () => {

//   if (
//     !projectForm.name.trim()
//   ) {
//     triggerToast(
//       "Project name is required",
//       "error"
//     );
//     return;
//   }

//   setProjectLoading(true);

//   try {

//     const response =
//       await requirementService.createProject(
//         projectForm
//       );

//     triggerToast(
//       response.message ||
//         "Project Created Successfully",
//       "success"
//     );

//     // Refresh dropdown
//     const updatedProjects =
//       await fetchProjectsList();

//     // Auto-select created project
//     const newProject =
//       updatedProjects.find(
//         (p) =>
//           p.name ===
//           projectForm.name
//       );

//     if (newProject) {
//       setFormData((prev) => ({
//         ...prev,
//         project:
//           newProject.id,
//       }));
//     }

//     // Reset modal form
//     setProjectForm({
//       name: "",
//       description: "",
//     });

//     setShowProjectModal(
//       false
//     );

//   } catch (error) {

//     console.error(error);

//     triggerToast(
//       error.message ||
//         "Failed to create project",
//       "error"
//     );

//   } finally {

//     setProjectLoading(
//       false
//     );
//   }
// };
//   const handleSave = async (e) => {
//     if (e) e.preventDefault(); 
//     setLoading(true);

//     try {
//       const storedUserId = localStorage.getItem("user_id");

//       if (!storedUserId) {
//         triggerToast("Session expired or user not found. Please log in again.", "error");
//         return;
//       }

//       const parsedUserId = parseInt(storedUserId, 10);

//       // =========================================================
//       // DYNAMIC MULTI-PART FORMDATA GENERATION PIPELINE
//       // =========================================================
//       const uploadData = new FormData();
      
//       // Append core flat form fields
//       uploadData.append("project", formData.project);
//       uploadData.append("requirement_id", requirementId);
//       uploadData.append("user", parsedUserId);
//       uploadData.append("requirement_title_reference", formData.requirement_title_reference);
//       uploadData.append("requirement_purpose", formData.requirement_purpose);
//       uploadData.append("requirement_description", formData.requirement_description);
//       uploadData.append("requirement_moscow", formData.requirement_moscow);
//       uploadData.append("priority", formData.priority);
//       uploadData.append("reference", formData.reference);
//       uploadData.append("technical_issues", formData.technical_issues);
//       uploadData.append("risk", formData.risk);
//       uploadData.append("high_level_dependencies", formData.high_level_dependencies);
//       uploadData.append("acceptance_criteria", formData.acceptance_criteria);
//       uploadData.append("verification_method", formData.verification_method);
      
//       // Append tracking text fields directly inside the data model row
//       uploadData.append("version_remark", versionRemark);

//       // Stringify your child nested tracking features array block
//       uploadData.append("features", JSON.stringify(features));

//       // Iteratively pack valid non-empty files and names into native multi-part lists
//       uploadedDocuments.forEach((doc) => {
//         if (doc.file_obj && doc.document_name.trim() !== "") {
//           uploadData.append("document_names[]", doc.document_name.trim());
//           uploadData.append("document_files[]", doc.file_obj);
//         }
//       });

//       // 4. Send MultiPart request payload to backend
//       const response = await requirementService.createRequirement(uploadData);
      
//       if (response && response.status !== false) {
//         triggerToast(response.message || "Requirement Saved Successfully!", "success");
//         // Clear metadata tracking variables on successful storage pipeline dispatch
//         setVersionRemark("");
//         setUploadedDocuments([{ document_name: "", file_obj: null }]);
//       } else {
//         triggerToast(response.message || "Failed to save requirement.", "error");
//       }
      
//     } catch (err) {
//       console.error("Submission Error:", err);

//       const extractErrors = (errorObj) => {
//         if (!errorObj || typeof errorObj !== "object") return null;
//         return Object.values(errorObj)
//           .map((messages) => {
//             return Array.isArray(messages) ? messages.join(" ") : messages;
//           })
//           .join("\n");
//       };

//       if (err.errors) {
//         const formattedError = extractErrors(err.errors);
//         triggerToast(formattedError || err.message || "Validation failed.", "error");
//       } else if (err.response && err.response.data && err.response.data.errors) {
//         const formattedError = extractErrors(err.response.data.errors);
//         triggerToast(formattedError || err.response.data.message || "Validation failed.", "error");
//       } else {
//         triggerToast(err.message || "System error. Please check server logs.", "error");
//       }

//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="req-page-wrapper">
//       <div className="req-container-modern">
//         {/* Top Action Bar */}
//         <div className="req-top-bar">
//           <div className="req-title-section">
//             <h1>New Requirement</h1>
//             <p className="id-display">Req. ID: <span>{requirementId}</span></p>
//           </div>
//           <div className="req-actions">
//             <button className="btn-secondary" onClick={downloadPDF}><FiDownload /> PDF</button>
//             <button className="btn-secondary" onClick={downloadDOC}><FiFileText /> DOC</button>
//             <button className="btn-primary" onClick={handleSave} disabled={loading}>
//               <FiSave /> {loading ? "Saving..." : "Save"}
//             </button>
//           </div>
//         </div>

//         {/* Main Form Table */}
//         <div className="req-content-card">
//           <table className="main-form-table">
//             <tbody>
//               {/* Project Selection Row */}
//               <tr>
//                 <td className="side-label">Select Project</td>
//                 <td>
//                   {projectsLoading ? (
//                     <p style={{ margin: 0, color: "#666" }}>Loading projects list...</p>
//                   ) : (
//                     <select 
//                       className="semi-input" 
//                       value={formData.project} 
//                       onChange={(e) => handleChange("project", e.target.value)}
//                       style={{ width: "100%", maxWidth: "400px" }}
//                     >
//                       {projects.map((proj) => (
//                         <option key={proj.id} value={proj.id}>
//                           {proj.name || proj.project_name || `Project ID ${proj.id}`}
//                         </option>
//                       ))}
//                     </select>
//                   )}
//       {/* <button
//         type="button"
//         className="create-project-btn"
//         onClick={() =>
//           setShowProjectModal(
//             true
//           )
//         }
//       >
//         + Create Project
//       </button> */}

//                 </td>
//               </tr>

//               {/* ID Selection Row */}
//               <tr>
//                 <td className="side-label">Requirement ID Config</td>
//                 <td>
//                   <div className="id-selector-group" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
//                     <select value={formData.type} onChange={(e) => handleChange("type", e.target.value)}>
//                       <option value="SR">Software (SR)</option>
//                       <option value="HW">Hardware (HW)</option>
//                     </select>

//                     <select value={formData.category} onChange={(e) => handleChange("category", e.target.value)}>
//                       <option value="AI">AI Module (AI)</option>
//                       <option value="FR">Functional (FR)</option>
//                       <option value="NFR">Non-Functional (NFR)</option>
//                       <option value="VR">Validation (VR)</option>
//                       <option value="CC">Compliance & Certification (CC)</option>
//                       <option value="BR">Business (BR)</option>
//                       <option value="DB">Database Management (DB)</option>
//                       <option value="API">Secure API Gateway Module (API)</option>
//                       <option value="ENC">Encryption & Key Management (ENC)</option>
//                       <option value="BKP">Backup & Disaster Recovery (BKP)</option>
//                       <option value="NV">Notification & Alerts Management (NV)</option>
//                       <option value="PRIV">Privacy & Data Protection (PRIV)</option>
//                       <option value="INT">Integration Requirement (INT)</option>
//                       <option value="ST">Global Standards (ST)</option>
//                     </select>

//                     {formData.category === "ST" && (
//                       <input 
//                         type="text"
//                         className="version-input"
//                         style={{ width: "120px" }}
//                         value={customStValue}
//                         onChange={(e) => setCustomStValue(e.target.value.toUpperCase())}
//                         placeholder="Enter ST Type..."
//                       />
//                     )}

// <div className="version-display">
//   {formData.version}
// </div>
//                   </div>
//                 </td>
//               </tr>

//               <tr>
//                 <td className="side-label">Requirement Title</td>
//                 <td><input className="full-input" value={formData.requirement_title_reference} onChange={(e) => handleChange("requirement_title_reference", e.target.value)} placeholder="Enter title or reference..." /></td>
//               </tr>

//               <tr>
//                 <td className="side-label">Purpose</td>
//                 <td><textarea className="full-input" rows="2" value={formData.requirement_purpose} onChange={(e) => handleChange("requirement_purpose", e.target.value)} /></td>
//               </tr>

//               <tr>
//                 <td className="side-label">Description</td>
//                 <td><textarea className="full-input" rows="3" value={formData.requirement_description} onChange={(e) => handleChange("requirement_description", e.target.value)} /></td>
//               </tr>

//               <tr>
//                 <td className="side-label">MoSCoW</td>
//                 <td>
//                   <select className="semi-input" value={formData.requirement_moscow} onChange={(e) => handleChange("requirement_moscow", e.target.value)}>
//                     <option>Must Have</option>
//                     <option>Should Have</option>
//                     <option>Could Have</option>
//                     <option>Won't Have</option>
//                   </select>
//                 </td>
//               </tr>

//               {/* FEATURES WITH HORIZONTAL SCROLL */}
//               <tr>
//                 <td className="side-label">Features</td>
//                 <td className="no-padding">
//                   <div className="horizontal-scroll-container">
//                     <table className="features-inner-table">
//                       <thead>
//                         <tr>
//                           <th>Title</th>
//                           <th>Description</th>
//                           <th>Feature</th>
//                           <th>MoSCoW</th>
//                           <th>Risk</th>
//                           <th>Dependencies</th>
//                           <th>Priority</th>
//                           <th>Standard Mapping</th>
//                           <th>Target Achievement</th>
//                           <th></th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {features.map((row, index) => (
//                           <tr key={index}>
//                             <td><input value={row.title} onChange={(e) => handleFeatureChange(index, "title", e.target.value)} /></td>
//                             <td><input value={row.description} onChange={(e) => handleFeatureChange(index, "description", e.target.value)} /></td>
//                             <td><input value={row.feature} onChange={(e) => handleFeatureChange(index, "feature", e.target.value)} /></td>
//                             <td>
//                               <select value={row.moscow} onChange={(e) => handleFeatureChange(index, "moscow", e.target.value)}>
//                                 <option>Must Have</option>
//                                 <option>Should Have</option>
//                                 <option>Could Have</option>
//                                 <option>Won't Have</option>
//                               </select>
//                             </td>
//                             <td><input value={row.risk} onChange={(e) => handleFeatureChange(index, "risk", e.target.value)} /></td>
//                             <td><input value={row.dependencies} onChange={(e) => handleFeatureChange(index, "dependencies", e.target.value)} /></td>
//                             <td>
//                               <select value={row.priority} onChange={(e) => handleFeatureChange(index, "priority", e.target.value)}>
//                                 <option>High</option>
//                                 <option>Medium</option>
//                                 <option>Low</option>
//                               </select>
//                             </td>
//                             <td><input value={row.self_standard_mapping} onChange={(e) => handleFeatureChange(index, "self_standard_mapping", e.target.value)} /></td>
//                             <td><input value={row.target_standard_achievement} onChange={(e) => handleFeatureChange(index, "target_standard_achievement", e.target.value)} /></td>
//                             <td><FiTrash2 className="row-del-btn" onClick={() => setFeatures(features.filter((_, i) => i !== index))} /></td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                   <button className="add-feature-link" onClick={() => setFeatures([...features, { title: '', description: '', feature: '', moscow: 'Must Have', risk: '', dependencies: '', priority: 'High', self_standard_mapping: '', target_standard_achievement: '' }])}>+ Add New Feature Row</button>
//                 </td>
//               </tr>

//               <tr>
//                 <td className="side-label">Priority</td>
//                 <td>
//                   <select className="semi-input" value={formData.priority} onChange={(e) => handleChange("priority", e.target.value)}>
//                     <option>High</option><option>Medium</option><option>Low</option><option>Critical</option>
//                   </select>
//                 </td>
//               </tr>
//               {["Reference", "Technical Issues", "Risk", "High-level Dependencies", "Acceptance Criteria", "Verification Method"].map((label) => {
//                 const key = label.toLowerCase().replace(/ /g, "_").replace(/-/g, "_");
//                 return (
//                   <tr key={label}>
//                     <td className="side-label">{label}</td>
//                     <td><textarea className="full-input" rows="2" value={formData[key] || ""} onChange={(e) => handleChange(key, e.target.value)} /></td>
//                   </tr>
//                 );
//               })}

//               {/* ========================================================= */}
//               {/* NEW SUBMISSION ATTACHMENTS HANDLING INTERFACE ROW         */}
//               {/* ========================================================= */}
//               <tr>
//                 <td className="side-label">Upload Documents / Images</td>
//                 <td>
//                   <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//                     {uploadedDocuments.map((doc, idx) => (
//                       <div key={idx} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
//                         <input 
//                           type="text"
//                           placeholder="Document Label Name (e.g., Schema Design)"
//                           value={doc.document_name}
//                           onChange={(e) => handleDocChange(idx, "document_name", e.target.value)}
//                           style={{ padding: "6px 10px", border: "1px solid #cbd5e1", borderRadius: "6px", width: "260px" }}
//                         />
//                         <input 
//                           type="file"
//                           accept="application/pdf, image/*"
//                           onChange={(e) => handleDocChange(idx, "file_obj", e.target.files[0])}
//                           style={{ fontSize: "13px" }}
//                         />
//                         {uploadedDocuments.length > 1 && (
//                           <FiTrash2 
//                             style={{ color: "#ef4444", cursor: "pointer" }} 
//                             onClick={() => removeDocumentRow(idx)} 
//                           />
//                         )}
//                       </div>
//                     ))}
//                     <button 
//                       type="button" 
//                       onClick={addDocumentRow}
//                       style={{
//                         alignSelf: "flex-start", display: "flex", alignItems: "center", gap: "4px",
//                         background: "none", border: "none", color: "#2563eb", cursor: "pointer", 
//                         fontSize: "13px", fontWeight: "600", padding: "4px 0"
//                       }}
//                     >
//                       <FiPlus /> Add Another Attachment File
//                     </button>
//                   </div>
//                 </td>
//               </tr>

//               {/* ========================================================= */}
//               {/* NEW INITIAL REQUIREMENT REMARK ENTRY BLOCK ROW             */}
//               {/* ========================================================= */}
//               <tr>
//                 <td className="side-label">Version Remark</td>
//                 <td>
//                   <textarea 
//                     className="full-input" 
//                     rows="2" 
//                     placeholder="Enter short log remark noting changes or initialization scope context..."
//                     value={versionRemark}
//                     onChange={(e) => setVersionRemark(e.target.value)}
//                   />
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           {/* ========================================================= */}
//           {/* NEW SUBMIT ACTION BLOCK POSITIONED AT BOTTOM OF FORM      */}
//           {/* ========================================================= */}
//           <div 
//             className="form-bottom-actions-bar" 
//             style={{ 
//               display: "flex", 
//               justifyContent: "flex-end", 
//               padding: "20px 24px", 
//               borderTop: "1px solid #e2e8f0", 
//               marginTop: "24px",
//               backgroundColor: "#f8fafc",
//               borderRadius: "0 0 12px 12px"
//             }}
//           >
//             <button 
//               className="btn-primary" 
//               onClick={handleSave} 
//               disabled={loading}
//               style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 24px", fontSize: "14.5px" }}
//             >
//               <FiSave /> {loading ? "Saving Requirement Row..." : "Save"}
//             </button>
//           </div>

//         </div>
//       </div>

//       {/* ========================================================= */}
//       {/* UPDATED MODERNISED TOAST BANNER DISPLAY                   */}
//       {/* ========================================================= */}
//       {toast.show && (
//         <div 
//           className={`toast-notification-banner ${toast.type}`}
//           style={{
//             position: "fixed",
//             top: "24px",
//             right: "24px",
//             background: "#ffffff",
//             padding: "14px 20px",
//             borderRadius: "10px",
//             boxShadow: "0 10px 25px rgba(15, 23, 42, 0.08), 0 4px 12px rgba(15, 23, 42, 0.04)",
//             display: "flex",
//             alignItems: "center",
//             gap: "12px",
//             zIndex: 999999,
//             minWidth: "320px",
//             maxWidth: "420px",
//             border: "1px solid #e2e8f0",
//             borderLeft: toast.type === "error" ? "4px solid #ef4444" : "4px solid #10b981",
//             animation: "toastSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards"
//           }}
//         >
//           {/* Subtle Accent Round Visual Circle */}
//           <div 
//             className="toast-indicator" 
//             style={{
//               width: "8px",
//               height: "8px",
//               borderRadius: "50%",
//               backgroundColor: toast.type === "error" ? "#ef4444" : "#10b981",
//               flexShrink: 0
//             }}
//           />
          
//           <span 
//             className="toast-text-body"
//             style={{
//               fontSize: "13.5px",
//               fontWeight: "500",
//               color: "#334155",
//               lineHeight: "1.4",
//               flexGrow: 1,
//               whiteSpace: "pre-line",
//               textTransform: "initial"
//             }}
//           >
//             {toast.message}
//           </span>

//           <button 
//             className="toast-clear" 
//             onClick={() => setToast({ show: false, message: "", type: "" })}
//             style={{
//               background: "transparent",
//               border: "none",
//               fontSize: "18px",
//               color: "#94a3b8",
//               cursor: "pointer",
//               padding: "0 2px",
//               lineHeight: 1,
//               transition: "color 0.15s ease"
//             }}
//             onMouseEnter={(e) => e.target.style.color = "#475569"}
//             onMouseLeave={(e) => e.target.style.color = "#94a3b8"}
//           >
//             &times;
//           </button>
//         </div>
//       )}

//       {/* Inline Animation Injection Rule Helper */}
//       <style>{`
//         @keyframes toastSlideIn {
//           from {
//             transform: translateX(40px);
//             opacity: 0;
//           }
//           to {
//             transform: translateX(0);
//             opacity: 1;
//           }
//         }
//       `}</style>
//       {showProjectModal && (
//   <div className="modal-overlay">
//     <div className="project-modal">
//       <h3>Create Project</h3>

//       <div className="modal-field">
//         <label>
//           Project Name
//         </label>

//         <input
//           type="text"
//           placeholder="Enter project name"
//           value={projectForm.name}
//           onChange={(e) =>
//             setProjectForm({
//               ...projectForm,
//               name:
//                 e.target.value,
//             })
//           }
//         />
//       </div>

//       <div className="modal-field">
//         <label>
//           Description
//         </label>

//         <textarea
//           rows="4"
//           placeholder="Enter description"
//           value={
//             projectForm.description
//           }
//           onChange={(e) =>
//             setProjectForm({
//               ...projectForm,
//               description:
//                 e.target.value,
//             })
//           }
//         />
//       </div>

//       <div className="modal-actions">
//         <button
//           className="cancel-btn"
//           onClick={() =>
//             setShowProjectModal(
//               false
//             )
//           }
//         >
//           Cancel
//         </button>

//         <button
//           className="save-project-btn"
//           onClick={
//             handleCreateProject
//           }
//           disabled={
//             projectLoading
//           }
//         >
//           {projectLoading
//             ? "Creating..."
//             : "Create Project"}
//         </button>
//       </div>
//     </div>
//   </div>
// )}
//     </div>
//   );
// };

// export default AddRequirement;





import React, { useState, useEffect } from "react";
import { FiSave, FiDownload, FiPlus, FiTrash2, FiFileText } from "react-icons/fi";
import { requirementService } from "../../services/ApiService";
import "./Requirement.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { saveAs } from "file-saver";
import htmlDocx from "html-docx-js/dist/html-docx";

const AddRequirement = () => {

  const [loading, setLoading] = useState(false);
  const [requirementId, setRequirementId] = useState("");
  const [customStValue, setCustomStValue] = useState("");
  const [showProjectModal, setShowProjectModal] =useState(false);

const [projectForm, setProjectForm] =useState({name: "",description: "",});

const [projectLoading, setProjectLoading] =useState(false);
  
  // New States for Projects Dropdown
  const [projects, setProjects] = useState([]);
  const [projectsLoading, setProjectsLoading] = useState(true);

  // Dynamic Document Upload Storage Tracking States
  const [uploadedDocuments, setUploadedDocuments] = useState([{ document_name: "", file_obj: null }]);
  const [versionRemark, setVersionRemark] = useState("");
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    project: "", // Holds selected project ID
    type: "SR",
    category: "FR",
    version: "V1",
    requirement_title_reference: "",
    requirement_purpose: "",
    requirement_description: "",
    requirement_moscow: "Must Have",
    priority: "High",
    reference: "",
    technical_issues: "",
    risk: "",
    high_level_dependencies: "",
    acceptance_criteria: "",
    verification_method: "",
  });

  const [features, setFeatures] = useState([
    { title: "", description: "", feature: "", moscow: "Must Have", risk: "", dependencies: "", priority: "High", self_standard_mapping: "", target_standard_achievement: "" }
  ]);

  // 1. Add this tracking state at the top of your component file
  const [toast, setToast] = useState({ show: false, message: "", type: "" });

  // Helper function to handle timing out the notification banner auto-dismissal
  const triggerToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "" });
    }, 5000); // Automatically fades out cleanly after 5 seconds
  };


// Allowed:
// A-Z a-z 0-9 space
// @ # ( ) _ -
// Disallowed:
// ; ' " < > { } [ ] \ / etc.

const VALID_TEXT_REGEX = /^[a-zA-Z0-9\s@#()_-]*$/;

const REQUIRED_FIELDS = [
  "project",
  "requirement_title_reference",
  "requirement_purpose",
  "requirement_description",
  "requirement_moscow",
  "priority",

  "reference",
  "technical_issues",
  "risk",
  "high_level_dependencies",
  "acceptance_criteria",
  "verification_method"
];

const validateForm = () => {
  const errors = {};

  // Required field validation
  REQUIRED_FIELDS.forEach((field) => {
    if (
      !formData[field] ||
      String(formData[field]).trim() === ""
    ) {
      errors[field] = "Please fill out this field";
    }
  });

  // Validate all formData text values
  Object.keys(formData).forEach((key) => {
    const value = formData[key];

    if (
      typeof value === "string" &&
      value.trim() !== "" &&
      !VALID_TEXT_REGEX.test(value)
    ) {
      errors[key] =
        "Only letters, numbers, spaces, @ # ( ) _ - are allowed";
    }

    if (
      typeof value === "string" &&
      value.includes(";")
    ) {
      errors[key] =
        "Semicolon (;) is not allowed";
    }
  });

  // Features validation
  features.forEach((feature, index) => {
    Object.keys(feature).forEach((key) => {
      const value = feature[key];

      if (
        typeof value === "string" &&
        value.trim() !== "" &&
        !VALID_TEXT_REGEX.test(value)
      ) {
        errors[`feature_${index}_${key}`] =
          `Feature Row ${index + 1}: Invalid characters`;
      }

      if (
        typeof value === "string" &&
        value.includes(";")
      ) {
        errors[`feature_${index}_${key}`] =
          `Feature Row ${index + 1}: Semicolon not allowed`;
      }
    });
  });
const handleVersionRemarkChange = (value) => {
  if (
    value !== "" &&
    !VALID_TEXT_REGEX.test(value)
  ) {
    return;
  }

  setVersionRemark(value);

  if (errors.versionRemark) {
    setErrors((prev) => ({
      ...prev,
      versionRemark: false,
    }));
  }
};
  // Uploaded document names
  uploadedDocuments.forEach((doc, index) => {
    if (
      doc.document_name &&
      !VALID_TEXT_REGEX.test(doc.document_name)
    ) {
      errors[`doc_${index}`] =
        `Document ${index + 1}: Invalid characters`;
    }
  });

  return errors;
};

const fetchProjectsList =
  async (
    selectFirst = false
  ) => {
    try {

      setProjectsLoading(
        true
      );

      const responseData =
        await requirementService.getProjects();

      let actualProjectsArray =
        [];

      // Defensive check
      if (
        Array.isArray(
          responseData
        )
      ) {
        actualProjectsArray =
          responseData;
      } else if (
        responseData &&
        Array.isArray(
          responseData.results
        )
      ) {
        actualProjectsArray =
          responseData.results;
      } else if (
        responseData &&
        Array.isArray(
          responseData.projects
        )
      ) {
        actualProjectsArray =
          responseData.projects;
      } else if (
        responseData &&
        typeof responseData ===
          "object"
      ) {
        const foundArray =
          Object.values(
            responseData
          ).find((val) =>
            Array.isArray(
              val
            )
          );

        if (foundArray) {
          actualProjectsArray =
            foundArray;
        }
      }

      setProjects(
        actualProjectsArray
      );

      // Select first project
      if (
        selectFirst &&
        actualProjectsArray.length >
          0
      ) {
        setFormData(
          (prev) => ({
            ...prev,
            project:
              actualProjectsArray[0]
                .id,
          })
        );
      }

      return actualProjectsArray;

    } catch (err) {

      console.error(
        "Error loading project array:",
        err
      );

      setProjects([]);

      return [];

    } finally {

      setProjectsLoading(
        false
      );
    }
  };


useEffect(() => {
  fetchProjectsList(true);
}, []);

  // Auto-generate ID based on selections
 useEffect(() => {
  if (!formData.project) return;

  const fetchIncrementedId = async () => {
    try {
      const finalCategory =
        formData.category === "ST"
          ? (customStValue || "ST")
          : formData.category;

      const queryPayload = {
        project: formData.project,
        type: formData.type,
        category: finalCategory,
        version: formData.version,
      };

      const result =
        await requirementService.generateRequirementId(
          queryPayload
        );

      if (result?.next_requirement_id) {
        setRequirementId(
          result.next_requirement_id
        );
      }
    } catch (error) {
      console.error(error);

      const localCategory =
        formData.category === "ST"
          ? (customStValue || "ST")
          : formData.category;

      setRequirementId(
        `${formData.type}/${localCategory}/${formData.version}/001`
      );
    }
  };

  fetchIncrementedId();

}, [
  formData.project,
  formData.type,
  formData.category,
  formData.version,
  customStValue
]);
const handleVersionRemarkChange = (value) => {
  if (
    value !== "" &&
    !VALID_TEXT_REGEX.test(value)
  ) {
    return;
  }

  setVersionRemark(value);

  if (errors.versionRemark) {
    setErrors((prev) => ({
      ...prev,
      versionRemark: false,
    }));
  }
};
const handleChange = (field, value) => {
  setFormData({
    ...formData,
    [field]: value,
  });

  if (errors[field]) {
    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  }
};

const handleFeatureChange = (
  index,
  field,
  value
) => {
  if (
    value !== "" &&
    !VALID_TEXT_REGEX.test(value)
  ) {
    return;
  }

  if (value.includes(";")) {
    return;
  }

  const updated = [...features];

  updated[index][field] = value;

  setFeatures(updated);
};

  // Document array helper interaction hooks
  const handleDocChange = (index, field, value) => {
    const updatedDocs = [...uploadedDocuments];
    updatedDocs[index][field] = value;
    setUploadedDocuments(updatedDocs);
  };

  const addDocumentRow = () => {
    setUploadedDocuments([...uploadedDocuments, { document_name: "", file_obj: null }]);
  };

  const removeDocumentRow = (index) => {
    setUploadedDocuments(uploadedDocuments.filter((_, i) => i !== index));
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text("Requirement Document", 14, 20);
    doc.setFontSize(12);
    doc.text(`Requirement ID: ${requirementId}`, 14, 30);

    const details = [
      ["Title", formData.requirement_title_reference],
      ["Purpose", formData.requirement_purpose],
      ["Description", formData.requirement_description],
      ["MoSCoW", formData.requirement_moscow],
      ["Priority", formData.priority],
      ["Reference", formData.reference],
      ["Technical Issues", formData.technical_issues],
      ["Risk", formData.risk],
      ["Dependencies", formData.high_level_dependencies],
      ["Acceptance Criteria", formData.acceptance_criteria],
      ["Verification Method", formData.verification_method],
    ];

    autoTable(doc, {
      startY: 40,
      head: [["Field", "Value"]],
      body: details,
    });

    doc.text("Features", 14, doc.lastAutoTable.finalY + 15);

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 20,
      head: [["Title", "Description", "Feature", "MoSCoW", "Risk", "Dependencies", "Priority"]],
      body: features.map((f) => [
        f.title,
        f.description,
        f.feature,
        f.moscow,
        f.risk,
        f.dependencies,
        f.priority,
      ]),
    });

    doc.save(`${requirementId}.pdf`);
  };

  const downloadDOC = () => {
    const featureRows =
      features.length > 0
        ? features
            .map(
              (f) => `
        <tr>
          <td>${f.title || ""}</td>
          <td>${f.description || ""}</td>
          <td>${f.feature || ""}</td>
          <td>${f.moscow || ""}</td>
          <td>${f.risk || ""}</td>
          <td>${f.dependencies || ""}</td>
          <td>${f.priority || ""}</td>
          <td>${f.self_standard_mapping || ""}</td>
          <td>${f.target_standard_achievement || ""}</td>
        </tr>
      `
            )
            .join("")
        : `<tr><td colspan="9"></td></tr>`;

    const htmlContent = `
    <html>
    <head>
      <style>
        body { font-family: Arial, sans-serif; margin: 20px; }
        table { width: 100%; border-collapse: collapse; table-layout: fixed; }
        td, th { border: 1px solid black; padding: 6px; font-size: 12px; word-wrap: break-word; vertical-align: top; }
        .label-cell { width: 18%; font-weight: bold; }
        .feature-title { font-weight: bold; }
        .feature-table td, .feature-table th { font-size: 10px; text-align: center; }
        .big-row { height: 50px; }
      </style>
    </head>
    <body>
      <div>${formData.requirement_title_reference}</div>
      <table>
        <tr><td class="label-cell">Requirement ID</td><td>${requirementId}</td></tr>
        <tr class="big-row"><td class="label-cell">Requirement Purpose</td><td>${formData.requirement_purpose}</td></tr>
        <tr class="big-row"><td class="label-cell">Requirement Description</td><td>${formData.requirement_description}</td></tr>
        <tr><td class="label-cell">Requirement MoSCoW</td><td>${formData.requirement_moscow}</td></tr>
        <tr>
          <td class="label-cell feature-title">Features</td>
          <td style="padding:0;">
            <table class="feature-table">
              <thead>
                <tr>
                  <th>Title</th><th>Description</th><th>Feature</th><th>MoSCoW</th><th>Risk</th><th>Dependencies</th><th>Priority</th><th>Self Standard Mapping</th><th>Target Standard Achievement</th>
                </tr>
              </thead>
              <tbody>${featureRows}</tbody>
            </table>
          </td>
        </tr>
        <tr><td class="label-cell">Priority</td><td>${formData.priority}</td></tr>
        <tr class="big-row"><td class="label-cell">Reference</td><td>${formData.reference}</td></tr>
        <tr class="big-row"><td class="label-cell">Technical Issues</td><td>${formData.technical_issues}</td></tr>
        <tr class="big-row"><td class="label-cell">Risk</td><td>${formData.risk}</td></tr>
        <tr class="big-row"><td class="label-cell">High-level Dependencies</td><td>${formData.high_level_dependencies}</td></tr>
        <tr class="big-row"><td class="label-cell">Acceptance Criteria</td><td>${formData.acceptance_criteria}</td></tr>
        <tr class="big-row"><td class="label-cell">Verification Method</td><td>${formData.verification_method}</td></tr>
      </table>
    </body>
    </html>`;

    const converted = htmlDocx.asBlob(htmlContent);
    saveAs(converted, `${requirementId}.docx`);
  };
const handleCreateProject =
  async () => {

  if (
    !projectForm.name.trim()
  ) {
    triggerToast(
      "Project name is required",
      "error"
    );
    return;
  }

  setProjectLoading(true);

  try {

    const response =
      await requirementService.createProject(
        projectForm
      );

    triggerToast(
      response.message ||
        "Project Created Successfully",
      "success"
    );

    // Refresh dropdown
    const updatedProjects =
      await fetchProjectsList();

    // Auto-select created project
    const newProject =
      updatedProjects.find(
        (p) =>
          p.name ===
          projectForm.name
      );

    if (newProject) {
      setFormData((prev) => ({
        ...prev,
        project:
          newProject.id,
      }));
    }

    // Reset modal form
    setProjectForm({
      name: "",
      description: "",
    });

    setShowProjectModal(
      false
    );

  } catch (error) {

    console.error(error);

    triggerToast(
      error.message ||
        "Failed to create project",
      "error"
    );

  } finally {

    setProjectLoading(
      false
    );
  }
};
  const handleSave = async (e) => {
    if (e) e.preventDefault(); 
  const validationErrors = validateForm();

  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
  triggerToast(
    "Please fill all required fields.",
    "error"
  );
    const firstError =
      Object.values(validationErrors)[0];

    triggerToast(firstError, "error");
    return;
  }

  setErrors({});

    setLoading(true);

    try {
      const storedUserId = localStorage.getItem("user_id");

      if (!storedUserId) {
        triggerToast("Session expired or user not found. Please log in again.", "error");
        return;
      }

      const parsedUserId = parseInt(storedUserId, 10);

      // =========================================================
      // DYNAMIC MULTI-PART FORMDATA GENERATION PIPELINE
      // =========================================================
      const uploadData = new FormData();
      
      // Append core flat form fields
      uploadData.append("project", formData.project);
      uploadData.append("requirement_id", requirementId);
      uploadData.append("user", parsedUserId);
      uploadData.append("requirement_title_reference", formData.requirement_title_reference);
      uploadData.append("requirement_purpose", formData.requirement_purpose);
      uploadData.append("requirement_description", formData.requirement_description);
      uploadData.append("requirement_moscow", formData.requirement_moscow);
      uploadData.append("priority", formData.priority);
      uploadData.append("reference", formData.reference);
      uploadData.append("technical_issues", formData.technical_issues);
      uploadData.append("risk", formData.risk);
      uploadData.append("high_level_dependencies", formData.high_level_dependencies);
      uploadData.append("acceptance_criteria", formData.acceptance_criteria);
      uploadData.append("verification_method", formData.verification_method);
      
      // Append tracking text fields directly inside the data model row
      uploadData.append("version_remark", versionRemark);

      // Stringify your child nested tracking features array block
      uploadData.append("features", JSON.stringify(features));

      // Iteratively pack valid non-empty files and names into native multi-part lists
      uploadedDocuments.forEach((doc) => {
        if (doc.file_obj && doc.document_name.trim() !== "") {
          uploadData.append("document_names[]", doc.document_name.trim());
          uploadData.append("document_files[]", doc.file_obj);
        }
      });

      // 4. Send MultiPart request payload to backend
      const response = await requirementService.createRequirement(uploadData);
      
      if (response && response.status !== false) {
        triggerToast(response.message || "Requirement Saved Successfully!", "success");
        // Clear metadata tracking variables on successful storage pipeline dispatch
        setVersionRemark("");
        setUploadedDocuments([{ document_name: "", file_obj: null }]);
      } else {
        triggerToast(response.message || "Failed to save requirement.", "error");
      }
      
    } catch (err) {
      console.error("Submission Error:", err);

      const extractErrors = (errorObj) => {
        if (!errorObj || typeof errorObj !== "object") return null;
        return Object.values(errorObj)
          .map((messages) => {
            return Array.isArray(messages) ? messages.join(" ") : messages;
          })
          .join("\n");
      };

      if (err.errors) {
        const formattedError = extractErrors(err.errors);
        triggerToast(formattedError || err.message || "Validation failed.", "error");
      } else if (err.response && err.response.data && err.response.data.errors) {
        const formattedError = extractErrors(err.response.data.errors);
        triggerToast(formattedError || err.response.data.message || "Validation failed.", "error");
      } else {
        triggerToast(err.message || "System error. Please check server logs.", "error");
      }

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="req-page-wrapper">
      <div className="req-container-modern">
        {/* Top Action Bar */}
        <div className="req-top-bar">
          <div className="req-title-section">
            <h1>New Requirement</h1>
            <p className="id-display">Req. ID: <span>{requirementId}</span></p>
          </div>
          <div className="req-actions">
            <button className="btn-secondary" onClick={downloadPDF}><FiDownload /> PDF</button>
            <button className="btn-secondary" onClick={downloadDOC}><FiFileText /> DOC</button>
            <button className="btn-primary" onClick={handleSave} disabled={loading}>
              <FiSave /> {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>

        {/* Main Form Table */}
        <div className="req-content-card">
          <table className="main-form-table">
            <tbody>
              {/* Project Selection Row */}
              <tr>
                <td className="side-label">Select Project</td>
                <td>
                  {projectsLoading ? (
                    <p style={{ margin: 0, color: "#666" }}>Loading projects list...</p>
                  ) : (
                    <select 
                      className="semi-input" 
                      value={formData.project} 
                      onChange={(e) => handleChange("project", e.target.value)}
                      style={{ width: "100%", maxWidth: "400px" }}
                    >
                      {projects.map((proj) => (
                        <option key={proj.id} value={proj.id}>
                          {proj.name || proj.project_name || `Project ID ${proj.id}`}
                        </option>
                      ))}
                    </select>
                  )}
      {/* <button
        type="button"
        className="create-project-btn"
        onClick={() =>
          setShowProjectModal(
            true
          )
        }
      >
        + Create Project
      </button> */}

                </td>
              </tr>

              {/* ID Selection Row */}
              <tr>
                <td className="side-label">Requirement ID Config</td>
                <td>
                  <div className="id-selector-group" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <select value={formData.type} onChange={(e) => handleChange("type", e.target.value)}>
                      <option value="SR">Software (SR)</option>
                      <option value="HW">Hardware (HW)</option>
                    </select>

                    <select value={formData.category} onChange={(e) => handleChange("category", e.target.value)}>
                      <option value="AI">AI Module (AI)</option>
                      <option value="FR">Functional (FR)</option>
                      <option value="NFR">Non-Functional (NFR)</option>
                      <option value="VR">Validation (VR)</option>
                      <option value="CC">Compliance & Certification (CC)</option>
                      <option value="BR">Business (BR)</option>
                      <option value="DB">Database Management (DB)</option>
                      <option value="API">Secure API Gateway Module (API)</option>
                      <option value="ENC">Encryption & Key Management (ENC)</option>
                      <option value="BKP">Backup & Disaster Recovery (BKP)</option>
                      <option value="NV">Notification & Alerts Management (NV)</option>
                      <option value="PRIV">Privacy & Data Protection (PRIV)</option>
                      <option value="INT">Integration Requirement (INT)</option>
                      <option value="ST">Global Standards (ST)</option>
                    </select>

                    {formData.category === "ST" && (
                      <input 
                        type="text"
                        className="version-input"
                        style={{ width: "120px" }}
                        value={customStValue}
                        onChange={(e) => setCustomStValue(e.target.value.toUpperCase())}
                        placeholder="Enter ST Type..."
                      />
                    )}

<div className="version-display">
  {formData.version}
</div>
                  </div>
                </td>
              </tr>

              <tr>
  <td className="side-label">Requirement Title *</td>
  <td>
    <input
      className={`full-input ${
        errors.requirement_title_reference
          ? "input-error"
          : ""
      }`}
      value={formData.requirement_title_reference}
      onChange={(e) =>
        handleChange(
          "requirement_title_reference",
          e.target.value
        )
      }
      placeholder="Enter title or reference..."
    />
  </td>
</tr>

<tr>
  <td className="side-label">Purpose *</td>
  <td>
    <textarea
      className={`full-input ${
        errors.requirement_purpose
          ? "input-error"
          : ""
      }`}
      rows="2"
      value={formData.requirement_purpose}
      onChange={(e) =>
        handleChange(
          "requirement_purpose",
          e.target.value
        )
      }
    />
  </td>
</tr>

<tr>
  <td className="side-label">Description *</td>
  <td>
    <textarea
      className={`full-input ${
        errors.requirement_description
          ? "input-error"
          : ""
      }`}
      rows="3"
      value={formData.requirement_description}
      onChange={(e) =>
        handleChange(
          "requirement_description",
          e.target.value
        )
      }
    />
  </td>
</tr>

              <tr>
                <td className="side-label">MoSCoW</td>
                <td>
                  <select className="semi-input" value={formData.requirement_moscow} onChange={(e) => handleChange("requirement_moscow", e.target.value)}>
                    <option>Must Have</option>
                    <option>Should Have</option>
                    <option>Could Have</option>
                    <option>Won't Have</option>
                  </select>
                </td>
              </tr>

              {/* FEATURES WITH HORIZONTAL SCROLL */}
              <tr>
                <td className="side-label">Features</td>
                <td className="no-padding">
                  <div className="horizontal-scroll-container">
                    <table className="features-inner-table">
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>Description</th>
                          <th>Feature</th>
                          <th>MoSCoW</th>
                          <th>Risk</th>
                          <th>Dependencies</th>
                          <th>Priority</th>
                          <th>Standard Mapping</th>
                          <th>Target Achievement</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {features.map((row, index) => (
                          <tr key={index}>
                            <td><input value={row.title} onChange={(e) => handleFeatureChange(index, "title", e.target.value)} /></td>
                            <td><input value={row.description} onChange={(e) => handleFeatureChange(index, "description", e.target.value)} /></td>
                            <td><input value={row.feature} onChange={(e) => handleFeatureChange(index, "feature", e.target.value)} /></td>
                            <td>
                              <select value={row.moscow} onChange={(e) => handleFeatureChange(index, "moscow", e.target.value)}>
                                <option>Must Have</option>
                                <option>Should Have</option>
                                <option>Could Have</option>
                                <option>Won't Have</option>
                              </select>
                            </td>
                            <td><input value={row.risk} onChange={(e) => handleFeatureChange(index, "risk", e.target.value)} /></td>
                            <td><input value={row.dependencies} onChange={(e) => handleFeatureChange(index, "dependencies", e.target.value)} /></td>
                            <td>
                              <select value={row.priority} onChange={(e) => handleFeatureChange(index, "priority", e.target.value)}>
                                <option>High</option>
                                <option>Medium</option>
                                <option>Low</option>
                              </select>
                            </td>
                            <td><input value={row.self_standard_mapping} onChange={(e) => handleFeatureChange(index, "self_standard_mapping", e.target.value)} /></td>
                            <td><input value={row.target_standard_achievement} onChange={(e) => handleFeatureChange(index, "target_standard_achievement", e.target.value)} /></td>
                            <td><FiTrash2 className="row-del-btn" onClick={() => setFeatures(features.filter((_, i) => i !== index))} /></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <button className="add-feature-link" onClick={() => setFeatures([...features, { title: '', description: '', feature: '', moscow: 'Must Have', risk: '', dependencies: '', priority: 'High', self_standard_mapping: '', target_standard_achievement: '' }])}>+ Add New Feature Row</button>
                </td>
              </tr>

              <tr>
                <td className="side-label">Priority</td>
                <td>
                  <select className="semi-input" value={formData.priority} onChange={(e) => handleChange("priority", e.target.value)}>
                    <option>High</option><option>Medium</option><option>Low</option><option>Critical</option>
                  </select>
                </td>
              </tr>
              {["Reference", "Technical Issues", "Risk", "High-level Dependencies", "Acceptance Criteria", "Verification Method"].map((label) => {
                const key = label.toLowerCase().replace(/ /g, "_").replace(/-/g, "_");
                return (
                  <tr key={label}>
                    <td className="side-label">{label}</td>
                    <td><textarea
  className={`full-input ${
    errors[key] ? "input-error" : ""
  }`}
  rows="2"
  value={formData[key] || ""}
  onChange={(e) => handleChange(key, e.target.value)}
 /></td>
                  </tr>
                );
              })}

              {/* ========================================================= */}
              {/* NEW SUBMISSION ATTACHMENTS HANDLING INTERFACE ROW         */}
              {/* ========================================================= */}
              <tr>
                <td className="side-label">Upload Documents / Images</td>
                <td>
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {uploadedDocuments.map((doc, idx) => (
                      <div key={idx} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                        <input 
                          type="text"
                          placeholder="Document Label Name (e.g., Schema Design)"
                          value={doc.document_name}
                          onChange={(e) => handleDocChange(idx, "document_name", e.target.value)}
                          style={{ padding: "6px 10px", border: "1px solid #cbd5e1", borderRadius: "6px", width: "260px" }}
                        />
                        <input 
                          type="file"
                          accept="application/pdf, image/*"
                          onChange={(e) => handleDocChange(idx, "file_obj", e.target.files[0])}
                          style={{ fontSize: "13px" }}
                        />
                        {uploadedDocuments.length > 1 && (
                          <FiTrash2 
                            style={{ color: "#ef4444", cursor: "pointer" }} 
                            onClick={() => removeDocumentRow(idx)} 
                          />
                        )}
                      </div>
                    ))}
                    <button 
                      type="button" 
                      onClick={addDocumentRow}
                      style={{
                        alignSelf: "flex-start", display: "flex", alignItems: "center", gap: "4px",
                        background: "none", border: "none", color: "#2563eb", cursor: "pointer", 
                        fontSize: "13px", fontWeight: "600", padding: "4px 0"
                      }}
                    >
                      <FiPlus /> Add Another Attachment File
                    </button>
                  </div>
                </td>
              </tr>

              {/* ========================================================= */}
              {/* NEW INITIAL REQUIREMENT REMARK ENTRY BLOCK ROW             */}
              {/* ========================================================= */}
              <tr>
                <td className="side-label">Version Remark</td>
                <td>
<textarea
  className={`full-input ${
    errors.versionRemark ? "input-error" : ""
  }`}
  rows="2"
  placeholder="Enter short log remark..."
  value={versionRemark}
  onChange={(e) =>
    handleVersionRemarkChange(e.target.value)
  }
/>
                </td>
              </tr>
            </tbody>
          </table>

          {/* ========================================================= */}
          {/* NEW SUBMIT ACTION BLOCK POSITIONED AT BOTTOM OF FORM      */}
          {/* ========================================================= */}
          <div 
            className="form-bottom-actions-bar" 
            style={{ 
              display: "flex", 
              justifyContent: "flex-end", 
              padding: "20px 24px", 
              borderTop: "1px solid #e2e8f0", 
              marginTop: "24px",
              backgroundColor: "#f8fafc",
              borderRadius: "0 0 12px 12px"
            }}
          >
            <button 
              className="btn-primary" 
              onClick={handleSave} 
              disabled={loading}
              style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 24px", fontSize: "14.5px" }}
            >
              <FiSave /> {loading ? "Saving Requirement Row..." : "Save"}
            </button>
          </div>

        </div>
      </div>

      {/* ========================================================= */}
      {/* UPDATED MODERNISED TOAST BANNER DISPLAY                   */}
      {/* ========================================================= */}
      {toast.show && (
        <div 
          className={`toast-notification-banner ${toast.type}`}
          style={{
            position: "fixed",
            top: "24px",
            right: "24px",
            background: "#ffffff",
            padding: "14px 20px",
            borderRadius: "10px",
            boxShadow: "0 10px 25px rgba(15, 23, 42, 0.08), 0 4px 12px rgba(15, 23, 42, 0.04)",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            zIndex: 999999,
            minWidth: "320px",
            maxWidth: "420px",
            border: "1px solid #e2e8f0",
            borderLeft: toast.type === "error" ? "4px solid #ef4444" : "4px solid #10b981",
            animation: "toastSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards"
          }}
        >
          {/* Subtle Accent Round Visual Circle */}
          <div 
            className="toast-indicator" 
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: toast.type === "error" ? "#ef4444" : "#10b981",
              flexShrink: 0
            }}
          />
          
          <span 
            className="toast-text-body"
            style={{
              fontSize: "13.5px",
              fontWeight: "500",
              color: "#334155",
              lineHeight: "1.4",
              flexGrow: 1,
              whiteSpace: "pre-line",
              textTransform: "initial"
            }}
          >
            {toast.message}
          </span>

          <button 
            className="toast-clear" 
            onClick={() => setToast({ show: false, message: "", type: "" })}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "18px",
              color: "#94a3b8",
              cursor: "pointer",
              padding: "0 2px",
              lineHeight: 1,
              transition: "color 0.15s ease"
            }}
            onMouseEnter={(e) => e.target.style.color = "#475569"}
            onMouseLeave={(e) => e.target.style.color = "#94a3b8"}
          >
            &times;
          </button>
        </div>
      )}

      {/* Inline Animation Injection Rule Helper */}
      <style>{`
        @keyframes toastSlideIn {
          from {
            transform: translateX(40px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
      {showProjectModal && (
  <div className="modal-overlay">
    <div className="project-modal">
      <h3>Create Project</h3>

      <div className="modal-field">
        <label>
          Project Name
        </label>

        <input
          type="text"
          placeholder="Enter project name"
          value={projectForm.name}
          onChange={(e) =>
            setProjectForm({
              ...projectForm,
              name:
                e.target.value,
            })
          }
        />
      </div>

      <div className="modal-field">
        <label>
          Description
        </label>

        <textarea
          rows="4"
          placeholder="Enter description"
          value={
            projectForm.description
          }
          onChange={(e) =>
            setProjectForm({
              ...projectForm,
              description:
                e.target.value,
            })
          }
        />
      </div>

      <div className="modal-actions">
        <button
          className="cancel-btn"
          onClick={() =>
            setShowProjectModal(
              false
            )
          }
        >
          Cancel
        </button>

        <button
          className="save-project-btn"
          onClick={
            handleCreateProject
          }
          disabled={
            projectLoading
          }
        >
          {projectLoading
            ? "Creating..."
            : "Create Project"}
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default AddRequirement;